import { Injectable } from '@angular/core';
import { RfqTabService } from './rfq/rfq-tab/rfq-tab.service';
import { RfqSetup } from '@approot/models';

@Injectable({
  providedIn: 'root'
})
export class TabServiceRegistryService {
  public readonly store = new Map<Symbol, RfqTabService>();

  public register(symbol: Symbol, service: RfqTabService) {
    this.store.set(symbol, service);
  }

  public deregister(symbol: Symbol) {
    this.store.delete(symbol);
  }

  public listStoredRequestIds(): number[] {
    const entries = [...this.store.values()];
    return entries.map(entry => {
      const requestId =
        entry.executedTradeInfo?.confirmRFEEvent?.quote?.requestId;
      return requestId;
    });
  }

  public findSetupByRequestId(requestId: number): RfqSetup {
    if (!requestId) {
      return null;
    }
    const keys = [...this.store.keys()];
    const match = keys.find(key => {
      return (
        this.store.get(key)?.executedTradeInfo?.confirmRFEEvent?.quote
          ?.requestId === requestId
      );
    });

    if (!match) {
      return null;
    }

    return this.store.get(match).executedTradeInfo.setup;
  }
}
